import React from 'react'

import IconContainer from './IconContainer'

const Pdf = ()=>
    <g>
        <polygon fill="#870000" points="44,27 4,27 1,23 5,19 43,19 47,23 " /> 
        <path fill="#E6E6E6" d="M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z" /> 
        <path fill="#B3B3B3" d="M31,1v10c0,1.105,0.895,2,2,2h10L31,1z" />
        <path fill="#BD0100" d="M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z" />
        <path fill="#FFFFFF" d="M20.071,30.645c0,0.878-0.259,1.556-0.776,2.033c-0.518,0.479-1.252,0.717-2.205,0.717h-0.596V36h-2.122 v-7.853h2.718c0.992,0,1.737,0.217,2.234,0.649C19.822,29.23,20.071,29.847,20.071,30.645z M16.494,31.666h0.387 c0.319,0,0.572-0.09,0.76-0.27c0.188-0.179,0.282-0.426,0.282-0.74c0-0.53-0.293-0.795-0.881-0.795h-0.548V31.666z" />
        <path fill="#FFFFFF" d="M27.988,31.907c0,1.311-0.361,2.32-1.083,3.029C26.184,35.646,25.17,36,23.863,36h-2.541v-7.853h2.718 c1.26,0,2.233,0.322,2.919,0.967C27.645,29.759,27.988,30.689,27.988,31.907z M25.786,31.982c0-0.72-0.142-1.253-0.427-1.601 c-0.284-0.348-0.717-0.521-1.297-0.521h-0.618v4.398h0.473c0.645,0,1.117-0.188,1.418-0.562S25.786,32.752,25.786,31.982z" />
        <path fill="#FFFFFF" d="M31.484,36h-2.089v-7.853h4.641v1.702h-2.551v1.499h2.353v1.702h-2.353V36z" />
    </g>

const BannerWarning = ({accentColor}) => (
        <g>
            <path
                d="M45.521,39.04L27.527,5.134c-1.021-1.948-3.427-2.699-5.375-1.679-.717,.376-1.303,.961-1.679,1.679L2.479,39.04c-.676,1.264-.635,2.791,.108,4.017,.716,1.207,2.017,1.946,3.42,1.943H41.993c1.403,.003,2.704-.736,3.42-1.943,.743-1.226,.784-2.753,.108-4.017ZM23.032,15h1.937c.565,0,1.017,.467,1,1.031l-.438,14c-.017,.54-.459,.969-1,.969h-1.062c-.54,0-.983-.429-1-.969l-.438-14c-.018-.564,.435-1.031,1-1.031Zm.968,25c-1.657,0-3-1.343-3-3s1.343-3,3-3,3,1.343,3,3-1.343,3-3,3Z"
                fill={accentColor}
                stroke={accentColor}
            />
        </g>
)

const AccountLogin = ({ accentColor }) => 
    <svg  height="17" width="17">
        <g>
            <path fill={accentColor} d="M38,1H10A5.006,5.006,0,0,0,5,6v8a1,1,0,0,0,2,0V6a3,3,0,0,1,3-3H38a3,3,0,0,1,3,3V42a3,3,0,0,1-3,3H10a3,3,0,0,1-3-3V34a1,1,0,0,0-2,0v8a5.006,5.006,0,0,0,5,5H38a5.006,5.006,0,0,0,5-5V6A5.006,5.006,0,0,0,38,1Z" />
            <path fill={accentColor} d="M20.546,32.891a1,1,0,0,0,1.042-.082l11-8a1,1,0,0,0,0-1.618l-11-8A1,1,0,0,0,20,16v6H7a2,2,0,0,0,0,4H20v6A1,1,0,0,0,20.546,32.891Z"/>
        </g>
    </svg>

const IconLarger = ({ size, name, ...props }) => (
    <IconContainer name={name} size={size} viewBox="0 0 48 48" {...props}>
        {(accentColor) => {
            const iconProps = { accentColor }
            switch (name) {
                case 'pdf':
                    return <Pdf {...iconProps} />
                case 'bannerWarning':
                    return <BannerWarning {...iconProps} />
                case 'accountLogin':
                    return <AccountLogin {...iconProps} />
                default:
                    throw Error(
                        `Icon with name '${name}' was not found in IconLarger.`,
                    )
            }
        }}
    </IconContainer>
)

export default IconLarger
